<template>
  <div class="sidebar-pinned">
    <Navbar />

    <main class="admin-main">

      <!-- ── Page Header ── -->
      <div class="page-header">
        <div class="container">
          <div class="d-flex align-items-center justify-content-between text-white flex-wrap"
            style="padding: 32px 0; gap: 16px;">
            <div class="d-flex align-items-center" style="gap: 16px;">
              <div class="header-icon-wrap">
                <i class="mdi mdi-currency-ngn" style="font-size: 22px;"></i>
              </div>
              <div>
                <h4 class="mb-0 font-weight-bold">Fund Manager</h4>
                <small style="opacity: .8;">Manage your funds here</small>
              </div>
            </div>

            <div class="text-right">
              <p class="mb-1" style="opacity:.8; font-size:.78rem; text-transform:uppercase; letter-spacing:.05em;">
                Wallet Balance
              </p>
              <h3 class="mb-0 font-weight-bold">
                <i class="mdi mdi-currency-ngn"></i>{{ wallet.amount | numeral("0,0.00") }}
              </h3>
            </div>
          </div>

          <div class="pb-4">
            <button type="button" class="btn btn-outline-light btn-sm" data-toggle="modal"
              data-target="#exampleModalCenter">
              <i class="fe fe-plus-circle mr-1"></i> Fund Wallet
            </button>
          </div>
        </div>
      </div>

      <div class="container mt-n3 pb-5">

        <!-- ── Transactions Table ── -->
        <div class="card table-card shadow mb-4">
          <div class="d-flex align-items-center px-4 pt-4 pb-3">
            <i class="fe fe-list text-primary mr-2"></i>
            <h6 class="mb-0 font-weight-bold">Summary</h6>
          </div>
          <div class="table-responsive">
            <table class="table align-td-middle mb-0">
              <thead class="table-head">
                <tr>
                  <th class="table-th">Date</th>
                  <th class="table-th">Description</th>
                  <th class="table-th">Amount</th>
                </tr>
              </thead>
              <tbody>
                <tr class="table-row" v-for="tran in trans" v-bind:key="tran.id">
                  <td class="py-2" style="font-size:.85rem;">
                    {{ tran.created_at | moment("dddd, MMMM Do YYYY") }}
                  </td>
                  <td class="py-2">
                    <span class="badge badge-soft-success">
                      <i class="mdi mdi-check-circle mr-1"></i> Successful
                    </span>
                  </td>
                  <td class="py-2 font-weight-bold">
                    <i class="mdi mdi-currency-ngn"></i>{{ tran.amount | numeral("0,0.00") }}
                  </td>
                </tr>
                <tr v-if="!trans || !trans.length">
                  <td colspan="3" class="text-center py-5 text-muted">
                    <i class="fe fe-inbox" style="font-size:2rem;opacity:0.3;"></i>
                    <p class="mt-2 mb-0">No transactions yet</p>
                  </td>
                </tr>
              </tbody>
            </table>
          </div>
        </div>

      </div>

      <!-- ── Fund Wallet Modal ── -->
      <div class="modal fade" id="exampleModalCenter" tabindex="-1" role="dialog"
        aria-labelledby="exampleModalCenterTitle" aria-hidden="true">
        <div class="modal-dialog modal-dialog-centered" role="document">
          <div class="modal-content">
            <div class="modal-header" style="background: linear-gradient(135deg, #1e3a5f, #2563eb);">
              <h6 class="modal-title text-white font-weight-bold mb-0" id="exampleModalCenterTitle">
                <i class="fe fe-plus-circle mr-2"></i> Fund Wallet
              </h6>
              <button type="button" class="close text-white ml-auto" data-dismiss="modal" aria-label="Close">
                <span aria-hidden="true">&times;</span>
              </button>
            </div>
            <div class="modal-body p-4">
              <div class="form-group mb-0">
                <label class="small font-weight-bold text-secondary">Amount</label>
                <input type="text" class="form-control" placeholder="0.00" v-model="useramount" />
              </div>
            </div>
            <div class="modal-footer" style="border-top: 1px solid #f1f5f9;">
              <button type="button" class="btn btn-outline-secondary" data-dismiss="modal">
                Close
              </button>

              <paystack :amount="useramount * 100" :email="user.email" :paystackkey="paystackkey"
                subaccount="ACCT_1cph9403ndiyub5" :reference="reference" :callback="callback" :close="close"
                :embed="false" v-if="useramount != null">
                <button type="button" class="btn btn-submit px-4">
                  <i class="fe fe-credit-card mr-1"></i> Pay {{ useramount }}
                </button>
              </paystack>
            </div>
          </div>
        </div>
      </div>
    </main>
  </div>
</template>

<script>
// // @ is an alias to /src
import Navbar from "@/views/Navbar.vue";
import paystack from "vue-paystack";

export default {
  components: {
    Navbar,
    paystack,
  },
  data() {
    return {
      wallet: "",
      useramount: "10000",
      paystackkey: "pk_test_3fd16bd413ec8142893ee30dc1170e21e939176f", //paystack public key
      user: null,
      trans: "",
    };
  },
  beforeMount() {
    this.user = JSON.parse(localStorage.getItem("user"));
    this.axios
      .get(`/api/v1/auth/getUserWallet`)
      .then((response) => {
        this.wallet = response.data.data;
        console.log(response);
      })
      .catch((error) => {
        console.error(error);
      });
  },
  computed: {
    reference() {
      let text = "";
      let possible =
        "ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789";

      for (let i = 0; i < 10; i++)
        text += possible.charAt(Math.floor(Math.random() * possible.length));

      return text;
    },
  },
  methods: {
    callback: function (response) {
      this.fundWallet();
      console.log(response);
    },
    close: function () {
      console.log("Payment closed");
    },
    fundWallet() {
      this.user = JSON.parse(localStorage.getItem("user"));
      this.axios
        .post("/api/v1/auth/fundWallet", {
          amount: this.useramount,
        })
        .then((response) => {
          console.log(response);
          this.getWallet();
          this.$breadstick.notify("Wallet funded Successfully!", {
            position: "top-right",
          });
        })
        .catch((error) => {
          console.log(error.response);
        });
    },
    getWallet() {
      this.user = JSON.parse(localStorage.getItem("user"));
      this.axios
        .get(`/api/v1/auth/getUserWallet`)
        .then((response) => {
          this.wallet = response.data.data;
          console.log(response);
        })
        .catch((error) => {
          console.error(error);
        });
    },
    getTrans() {
      this.user = JSON.parse(localStorage.getItem("user"));
      this.axios
        .get(`/api/v1/auth/getTransUser`)
        .then((response) => {
          this.trans = response.data.data;
          console.log(response);
        })
        .catch((error) => {
          console.error(error);
        });
    },
  },
  created() {
    this.getTrans();
  },
};
</script>
